module.exports = __webpack_public_path__ + "static/release-it-8fb493519bdd4ed5022e08c59dc4e058.jpeg";